import { render, staticRenderFns } from "./notification-template-modal.vue?vue&type=template&id=ae2e928c&scoped=true"
import script from "./notification-template-modal.vue?vue&type=script&lang=js"
export * from "./notification-template-modal.vue?vue&type=script&lang=js"
import style0 from "./notification-template-modal.vue?vue&type=style&index=0&id=ae2e928c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae2e928c",
  null
  
)

export default component.exports